import { Path } from '@/main/router/routerPath';

import { NAME as name, CRUMB_LABEL_KEY } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';

export const router = new Path(name, { Edit, List }, CRUMB_LABEL_KEY);
